import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Contact from './pages/Contact';
import Presse from './pages/Presse';
import {
  Robinetterie,
  Vasques,
  Accessoires,
  CollectionHeritage,
} from './pages/CollectionPage';
import './styles/global.css';
import './pages/Home.css';

// Scroll to top on every route change
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

// Simple sub-page for sub-categories (e.g. /robinetterie/douches)
function SubPage({ title, label, img, items }) {
  const { CollectionPage } = require('./pages/CollectionPage');
  return (
    <CollectionPage
      title={title}
      label={label}
      products={items}
    />
  );
}

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/"                          element={<Home />} />
        <Route path="/collection-heritage"       element={<CollectionHeritage />} />
        <Route path="/robinetterie"              element={<Robinetterie />} />
        <Route path="/robinetterie/*"            element={<Robinetterie />} />
        <Route path="/vasques"                   element={<Vasques />} />
        <Route path="/vasques/*"                 element={<Vasques />} />
        <Route path="/accessoires"               element={<Accessoires />} />
        <Route path="/accessoires/*"             element={<Accessoires />} />
        <Route path="/creations"                 element={<Accessoires />} />
        <Route path="/presse"                    element={<Presse />} />
        <Route path="/contact"                   element={<Contact />} />
        <Route path="*"                          element={<Home />} />
      </Routes>
      <Footer />
    </Router>
  );
}
